import { CSSProperties } from 'react';
import { IconType } from '.';

interface CloudCheckmarkProps extends IconType {
  style?: CSSProperties;
}

export default function CloudCheckmark({ className = '', color = '#5b667d', height = 14, style, width = 14 }: CloudCheckmarkProps) {
  return (
    <svg width={width} height={height} style={style} className={className} viewBox="0 0 14 14">
      <path
        fill={color}
        d="M7,0A2.625,2.625,0,0,1,9.321,1.4a2.582,2.582,0,0,1,2.628.653A2.68,2.68,0,0,1,12.6,4.679a2.627,2.627,0,0,1,0,4.643,2.636,2.636,0,0,1-.654,2.628,2.692,2.692,0,0,1-2.628.654,2.627,2.627,0,0,1-4.643,0A2.626,2.626,0,0,1,1.4,9.321a2.627,2.627,0,0,1,0-4.643A2.571,2.571,0,0,1,2.05,2.05,2.623,2.623,0,0,1,4.679,1.4,2.625,2.625,0,0,1,7,0ZM9.628,6.128a.594.594,0,0,0,0-.905.632.632,0,0,0-.905,0l-2.6,2.6L5.034,6.754a.64.64,0,0,0-.905.905L5.66,9.19a.594.594,0,0,0,.905,0Z"
      />
    </svg>
  );
}
